export { ImageWithTitleAndDescription } from "./ImageWithTitleAndDescription"